import React from 'react';
import PropTypes from 'prop-types';
import css from './ReservationProfileDetails.module.scss';
import FlexContainer from '../FlexContainer/FlexContainer.jsx';
import DetailRow from '../DetailRow/DetailRow.jsx';
import ReservationProfileSectionTitle from './ReservationProfileSectionTitle.jsx';
import RoomTypeCode from '../SetupItemLookup/RoomTypeCode.jsx';
import Edit04 from '../Icons/Edit04.jsx';
import {formatDate} from '../../utils/formatDate.js';

const EXCLUDED_METADATA_KEYS = ['reservationDailyRates'];

const formatMetadataKey = (key) => {
  const spaced = key.replace(/([A-Z])/g, ' $1');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

const shouldShowMetadataEntry = (key) => {
  if (EXCLUDED_METADATA_KEYS.includes(key)) {
    return false;
  }
  if (key.includes('Opportunity')) {
    return false;
  }
  return true;
};

const ReservationProfileDetails = ({
  reservationProfile,
  onEditDatesClick,
}) => {
  const checkinDisplay = formatDate(reservationProfile.checkin, 'd MMM');
  const checkoutDisplay = formatDate(reservationProfile.checkout, 'd MMM');

  return (
    <div className={css.reservationDetails}>
      <ReservationProfileSectionTitle>Reservation Details</ReservationProfileSectionTitle>
      <FlexContainer gap={15} justifyContent="space-between">
        <DetailRow
          label="Check In"
          value={checkinDisplay}
          icon={onEditDatesClick ? <Edit04 /> : undefined}
          iconClick={onEditDatesClick}
        />
        <DetailRow
          label="Check Out"
          value={checkoutDisplay}
          icon={onEditDatesClick ? <Edit04 /> : undefined}
          iconClick={onEditDatesClick}
        />
      </FlexContainer>
      <DetailRow
        label="Current Room Type"
        value={<RoomTypeCode id={reservationProfile.roomTypeId} />}
      />
      <DetailRow
        label="Booked Room Type"
        value={<RoomTypeCode id={reservationProfile.bookedRoomTypeId} />}
      />
      <FlexContainer gap={15} justifyContent="space-between">
        <DetailRow label="Adults" value={reservationProfile.adults} />
        <DetailRow label="Children" value={reservationProfile.children} />
      </FlexContainer>
      {reservationProfile.metadata &&
        <FlexContainer gap={15}>
          {Object.entries(reservationProfile.metadata).map(([key, value]) => {
            if (!shouldShowMetadataEntry(key)) {
              return null;
            }
            return (
              <DetailRow
                key={key}
                label={formatMetadataKey(key)}
                value={value}
              />
            );
          })}
        </FlexContainer>
      }
    </div>
  );
};

ReservationProfileDetails.propTypes = {
  reservationProfile: PropTypes.shape({
    checkin: PropTypes.string,
    checkout: PropTypes.string,
    roomTypeId: PropTypes.number,
    bookedRoomTypeId: PropTypes.number,
    adults: PropTypes.number,
    children: PropTypes.number,
    metadata: PropTypes.object,
  }).isRequired,
  onEditDatesClick: PropTypes.func,
};

export default ReservationProfileDetails;
